module.exports = __webpack_public_path__ + "img/express-box.0e5141e4.png";